import { createContext, useContext } from 'react';

export const PORTAL_TERMS_REQUIRED_EVENT = 'ths-portal-terms-required';
export const PortalTermsContext = createContext<{
  requiresAcceptance: boolean;
  review: () => void;
} | null>(null);
export const usePortalTerms = () => useContext(PortalTermsContext);
export const TERMS_EXEMPT_MUTATIONS = new Set([
  'acceptHotelPortalTerms',
  'removeHotelSavedCard',
  'setDefaultHotelSavedCard',
  'closeUnreceivedHotelBookingRequest',
  'sendBookingConfirmationEmail',
]);
